import React from 'react';

import "./E404.scss";

export const E404 = ()=>{
    return (
        <section className="E404">
            <h1>404</h1>
        </section>
    )
}

export default E404;
